/* eslint-disable react/prop-types */
import React from "react";

import styles from "./CustomProductOptionBrandRefresh.module.css";
import LimitedTimeBadge from "./LimitedTimeBadge";
import VeganBadge from "./VeganBadge";
import GlutenFreeBadge from "./GlutenFreeBadge";

// Only these backend meta tag titles (see App\Enums\Product\MetaTagsEnum
// in the website-laravel repo) should render as visual promo badges on the
// brand refresh card. All other meta tags (Classic, Deluxe, Brownie, Mini,
// flavor tags, etc.) are used for category filtering elsewhere and must
// NOT produce a badge here.
const BADGE_CONFIG = {
  LTO: { label: "Limited Time", style: "lto" },
  Vegan: { label: "Vegan", style: "vegan" },
  "Gluten Free": { label: "Gluten Free", style: "glutenFree" },
};

const BrandRefreshBadges = ({ metaTags = [] }) => {
  const badges = [];

  metaTags.forEach(tag => {
    if (!tag || !tag.title) return;
    const config = BADGE_CONFIG[tag.title];
    if (!config) return;
    badges.push({
      key: `meta-${tag.title}`,
      title: config.label,
      style: config.style,
    });
  });

  if (badges.length === 0) return null;

  return (
    <div className={styles.badgeOverlay} data-part="product-badge-region">
      {badges.map(badge => {
        if (badge.style === "lto") {
          return (
            <LimitedTimeBadge
              key={badge.key}
              className={styles.badgeSvg}
              data-part="product-badge"
            />
          );
        }
        if (badge.style === "vegan") {
          return (
            <VeganBadge
              key={badge.key}
              className={styles.veganBadge}
              data-part="product-badge"
            />
          );
        }
        if (badge.style === "glutenFree") {
          return (
            <GlutenFreeBadge
              key={badge.key}
              className={styles.glutenFreeBadge}
              data-part="product-badge"
            />
          );
        }
        return (
          <span
            key={badge.key}
            className={styles.badge}
            data-part="product-badge"
          >
            {badge.title}
          </span>
        );
      })}
    </div>
  );
};

export default BrandRefreshBadges;